<script setup lang="ts">
import type { otherEvaluateList } from '~/server/newhouse/interface'
import config from '~/common/config'
import { computedStatusColor } from '~/utils/utils-js'

const props = defineProps<otherEvaluateList>()
const floorInfo: any = props.floorInfo
const imgSrc = computed(() => floorInfo?.ad === 1 ? (floorInfo?.mobileAdUrl || floorInfo?.photo || config.DEFAULT_HOUSE_PIC) : (floorInfo?.photo || config.DEFAULT_HOUSE_PIC))
const point = computed(() => (props?.totalPoint || 0) / 20)

const saleStatus = computed(() => {
  // const { saleStatusIdList, saleStatusList } = floorInfo
  const saleStatusIdList = floorInfo?.saleStatusIdList
  const saleStatusList = floorInfo?.saleStatusList
  if (saleStatusIdList && saleStatusIdList[0] && saleStatusList && saleStatusList[0]) {
    return {
      saleStatusId: saleStatusIdList[0],
      saleStatus: saleStatusList[0],
    }
  }
  else {
    return undefined
  }
})
</script>

<template>
  <a :href="getFloorIndexUrl(props?.floorId as number)">
    <div class="data-li">
      <div class="pic">
        <img :src="imgSrc" alt="">
        <div class="address">
          <span class="score" style="font-size: 12px">综合得分</span>
          <a-rate v-model:value="point" allow-half disabled style="font-size: 10px;margin-right: 10px;color: #FFFFFF" />
          <span>{{ props?.totalPoint ?? 0 }}分</span>
        </div>
        <div v-if="floorInfo?.openingDate" class="item-badge">
          {{ floorInfo?.openingDate }}<span style="font-size: 10px">月开</span>
        </div>
      </div>
      <div class="info">
        <div class="title">
          {{ floorInfo?.floor }}
        </div>
        <div class="buildArea">
          {{ floorInfo?.areaName ? `${floorInfo?.areaName}   ` : null }}{{ (floorInfo?.modelAreaLow && floorInfo?.modelAreaHigh) ? `|建面${floorInfo?.modelAreaLow}~${floorInfo?.modelAreaHigh}㎡` : null }}
        </div>
        <tag v-if="saleStatus?.saleStatusId" style="margin-top: 10px" :color="computedStatusColor(saleStatus)">
          {{ saleStatus?.saleStatus }}
        </tag>
        <template v-if="floorInfo?.floorLabel">
          <tag v-for="item in floorInfo?.floorLabel?.split(',')" :key="item" style="margin-top: 10px">
            {{ item }}
          </tag>
        </template>
        <!--        <tag v-if="floorInfo?.saleStatus === '在售'" color="green"> -->
        <!--          {{ floorInfo?.saleStatus }} -->
        <!--        </tag> -->
        <!--        <tag v-else-if="floorInfo?.saleStatus === '待售'" color="blue"> -->
        <!--          {{ floorInfo?.saleStatus }} -->
        <!--        </tag> -->
        <!--        <tag v-else-if="floorInfo?.saleStatus === '售完'" color="gray"> -->
        <!--          {{ floorInfo?.saleStatus }} -->
        <!--        </tag> -->
        <div class="price">
          <!--        {{ floorInfo?.priceDisplay }} -->
          <small>
            {{ floorInfo?.pricePrefix }}
          </small>
          {{ floorInfo?.price }}
          <small>
            {{ floorInfo?.priceSuffix }}
          </small>
        </div>
      </div>
    </div>
  </a>
</template>

<style lang="scss" scoped>
a {
  &:hover {
    color: unset;
  }
}
:deep(:where(.css-dev-only-do-not-override-1k8gdg4).ant-rate .ant-rate-star:not(:last-child)) {
  margin-inline-end: 5px;
}

:deep(.ant-rate-star-zero .ant-rate-star-first,.ant-rate-star-zero .ant-rate-star-second) {
  color: #d9d9d9; /* 你想要的未选中状态下的颜色 */
}
.data-li {
  .pic {
    width: 210px;
    height: 135px;
    //overflow: hidden;
    position: relative;

    .item-badge{
      width: 52px;
      height: 25px;
      background: url('https://imgf1.fccs.com.cn/newhouse/v8/floorEvaluating/icon_openbg.png') no-repeat;
      background-size: 100% 100%;
      font-size: 13px;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #FFFFFF;
      position: absolute;
      top: 0;
      left: -5px;
      padding-top: 4px;
      font-weight: bold;
    }
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      //position: absolute;
      //top: 50%;
      //left: 50%;
      //transform: translate(-50%, -50%);
      z-index: -1;
      border-radius: 5px;
    }

    .address {
      color: #FFFFFF;
      font-size: 13px;
      font-weight: bold;
      padding: 3px 9px;
      position: absolute;
      bottom: 9px;
      left: 0px;
      display: flex;
      align-items: center;
      width: 100%;
      @include ell();
      .score{
        flex: 1;
      }
    }
  }

  .info {
    margin-top: 10px;
    .title {
      font-size: 16px;
      font-weight: bold;
      width: 210px;
      @include ell();

      .area {
        font-size: 14px;
        font-weight: normal;
      }
    }
    .price {
      margin-top: 10px;
      font-size: 16px;
      font-weight: bold;
      color: #FF5B05;
    }
    .buildArea {
      margin-top: 10px;
      font-size: 14px;
      font-weight: normal;
      color: #767676;
    }
  }
}
</style>
